var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlueBoxes = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 908.406848820943196 672.505281394523081",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2152d0;}.cls-2{fill:#126cfc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 699.6983132157493,
    y: 463.7967457893292,
    width: 208.7085356051939,
    height: 208.7085356051939,
    rx: 16.505433802962216,
    ry: 16.505433802962216
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 699.6983132157493,
    y: 231.89837289466323,
    width: 208.7085356051939,
    height: 208.70853560519572,
    rx: 16.505433802962216,
    ry: 16.505433802962216
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 699.6983132157493,
    width: 208.7085356051939,
    height: 208.7085356051948,
    rx: 16.505433802962216,
    ry: 16.505433802962216
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 466.47887570178864,
    y: 463.7967457893292,
    width: 208.7085356051939,
    height: 208.7085356051939,
    rx: 16.505433802962216,
    ry: 16.505433802962216
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 463.7967457893292,
    width: 208.7085356051948,
    height: 208.7085356051939,
    rx: 16.50543380296402,
    ry: 16.50543380296402
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 442.3619498697562,
    y: 208.70853560519078,
    width: 208.70853560519532,
    height: 208.7085356051947,
    rx: 16.505433802963452,
    ry: 16.505433802963452,
    transform: "translate(98.915697371531223 -130.08687284372462) rotate(14.90442733837755)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlueBoxes);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJMYXllcl8yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5MDguNDA2ODQ4ODIwOTQzMTk2IDY3Mi41MDUyODEzOTQ1MjMwODEiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMjE1MmQwO30uY2xzLTJ7ZmlsbDojMTI2Y2ZjO308L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMi0yIj48cmVjdCBjbGFzcz0iY2xzLTIiIHg9IjY5OS42OTgzMTMyMTU3NDkyOTUiIHk9IjQ2My43OTY3NDU3ODkzMjkxNzkiIHdpZHRoPSIyMDguNzA4NTM1NjA1MTkzOTAyIiBoZWlnaHQ9IjIwOC43MDg1MzU2MDUxOTM5MDIiIHJ4PSIxNi41MDU0MzM4MDI5NjIyMTYiIHJ5PSIxNi41MDU0MzM4MDI5NjIyMTYiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjY5OS42OTgzMTMyMTU3NDkyOTUiIHk9IjIzMS44OTgzNzI4OTQ2NjMyMjUiIHdpZHRoPSIyMDguNzA4NTM1NjA1MTkzOTAyIiBoZWlnaHQ9IjIwOC43MDg1MzU2MDUxOTU3MjEiIHJ4PSIxNi41MDU0MzM4MDI5NjIyMTYiIHJ5PSIxNi41MDU0MzM4MDI5NjIyMTYiLz48cmVjdCBjbGFzcz0iY2xzLTIiIHg9IjY5OS42OTgzMTMyMTU3NDkyOTUiIHdpZHRoPSIyMDguNzA4NTM1NjA1MTkzOTAyIiBoZWlnaHQ9IjIwOC43MDg1MzU2MDUxOTQ4MTEiIHJ4PSIxNi41MDU0MzM4MDI5NjIyMTYiIHJ5PSIxNi41MDU0MzM4MDI5NjIyMTYiLz48cmVjdCBjbGFzcz0iY2xzLTIiIHg9IjQ2Ni40Nzg4NzU3MDE3ODg2MzgiIHk9IjQ2My43OTY3NDU3ODkzMjkxNzkiIHdpZHRoPSIyMDguNzA4NTM1NjA1MTkzOTAyIiBoZWlnaHQ9IjIwOC43MDg1MzU2MDUxOTM5MDIiIHJ4PSIxNi41MDU0MzM4MDI5NjIyMTYiIHJ5PSIxNi41MDU0MzM4MDI5NjIyMTYiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHk9IjQ2My43OTY3NDU3ODkzMjkxNzkiIHdpZHRoPSIyMDguNzA4NTM1NjA1MTk0ODExIiBoZWlnaHQ9IjIwOC43MDg1MzU2MDUxOTM5MDIiIHJ4PSIxNi41MDU0MzM4MDI5NjQwMjEiIHJ5PSIxNi41MDU0MzM4MDI5NjQwMjEiLz48cmVjdCBjbGFzcz0iY2xzLTIiIHg9IjQ0Mi4zNjE5NDk4Njk3NTYxODgiIHk9IjIwOC43MDg1MzU2MDUxOTA3NzUiIHdpZHRoPSIyMDguNzA4NTM1NjA1MTk1MzIzIiBoZWlnaHQ9IjIwOC43MDg1MzU2MDUxOTQ2OTciIHJ4PSIxNi41MDU0MzM4MDI5NjM0NTIiIHJ5PSIxNi41MDU0MzM4MDI5NjM0NTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDk4LjkxNTY5NzM3MTUzMTIyMyAtMTMwLjA4Njg3Mjg0MzcyNDYyKSByb3RhdGUoMTQuOTA0NDI3MzM4Mzc3NTUpIi8+PC9nPjwvc3ZnPg==";